import Vue from 'vue'
import App from './document_categories/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const funnelBuilder = document.getElementById('document-category-builder');

  if (funnelBuilder) {
    new Vue({
      el: '#document-category-builder',
      render: h => h(App)
    }).$mount();
  }
});